// src/hooks/useRequireAuth.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const useRequireAuth = (requiredRole = null) => {
  const { user, loading, isAuthenticated, isAdmin } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (!isAuthenticated()) {
        navigate('/login');
        return;
      }

      if (requiredRole === 'admin' && !isAdmin()) {
        navigate('/unauthorized');
        return;
      }
    }
  }, [user, loading, navigate, isAuthenticated, isAdmin, requiredRole]);

  return { user, loading };
};